<script setup lang="ts">
import {
  PhxsgSection as PhxsgCoreSection,
  type PhxsgSectionProps as PhxsgCoreSectionProps,
} from '@sg-core/src/View/Components/Atoms/Section';

export type PhxsgSectionTheme = 'neutral-97' | 'blue-80' | 'blue-textured' | 'white';

export interface PhxsgSectionProps extends PhxsgCoreSectionProps {
  theme?: PhxsgSectionTheme;
}

const isBlueTextured = (theme?: PhxsgSectionTheme): boolean => theme === 'blue-textured';

defineProps<PhxsgSectionProps>();
</script>

<template>
  <PhxsgCoreSection :use="use" :spacing="spacing" :class="{ [`phxsg-theme-${theme}`]: theme }">
    <svg v-if="isBlueTextured(theme)" class="phxsg-section__texture" aria-hidden="true" width="100%" height="100%">
      <defs>
        <filter id="{{ $getNoiseFilterId() }}">
          <feTurbulence type="fractalNoise" baseFrequency="30.5" result="turbulence" />
          <feColorMatrix in="turbulence" type="saturate" values="0.5" />
        </filter>
      </defs>
      <rect x="0" y="0" width="100%" height="100%" filter="url(#{{ $getNoiseFilterId() }})" />
    </svg>

    <slot />
  </PhxsgCoreSection>
</template>

<style src="./section.css" />
